type ClaimUnavailablePanelProps = {
  message?: string;
};

export default function ClaimUnavailablePanel({message}: ClaimUnavailablePanelProps) {
  return (
    <div className="flex flex-col gap-4 text-center">
      <p className="text-foreground">
        {message ?? "Resident claim is currently disabled."}
      </p>
      <p className="text-sm text-muted-foreground">
        Please contact your property management office for assistance.
      </p>
    </div>
  );
}
